import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import ReactSelect from "react-select";
import { useEntityCrud } from "../../hooks/useEntityCrud";
import InputMask from 'react-input-mask';
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";

const RankOpinionQuestion = () => {

  const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

  const { readData: getReports } = useEntityCrud("Report/RankBaseQuestion");

  const [opinion, setOpinion] = useState(0);
  const { readData: getOpinions } = useEntityCrud("Opinions/getAll");
  const [opinions, setOpinions] = useState([]);

  const [questionId, setQuestionId] = useState(0);
  const { readData: getQuestions } = useEntityCrud(`Question/getAll?opinionId=${opinion}`);
  const [questions, setQuestions] = useState([]);

  const [isSearched, setIsSearched] = useState(false);
  const [rows, setRows] = useState([]);
  const [options, setOptions] = useState({});

  const [isAdvanced, setIsAdvanced] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [showItem, setShowItem] = useState(true);

  const [branchId, setBranchId] = useState([]);
  const [branchs, setBranchs] = useState([]);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [cityId, setCityId] = useState(0);
  const [provinceId, setProvinceId] = useState(0);
  const { readGetDataById: getProvinces } = useEntityCrud('Info/GetProvinces');
  const { readGetDataById: getCities } = useEntityCrud(`Info/GetCities?provinceId=${provinceId}`);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);


  useEffect(() => {
    getOpinions().then(({ data }) => {
      let opinionsArr = [];
      if (data.status)
        data.result.map((item) => {
          opinionsArr.push({
            label: item.title,
            value: item.id,
          });
        });
      setOpinions(opinionsArr);
    });

    getProvinces().then(({ data }) => {
      let getProvinces = [];
      data.result.map(item => getProvinces.push({
        label: item.title,
        value: item.id
      }))
      setProvinces(getProvinces);
    })
  }, []);


  useEffect(() => {
    if (provinceId != 0)
      getCities().then(({ data }) => {
        if (data.status) {
          let getCities = [];
          data.result.map(item => getCities.push({
            label: item.title,
            value: item.id
          }))
          setCities(getCities);
        }
      });
  }, [provinceId])


  useEffect(() => {
    getQuestions().then(({ data }) => {
      let opinionsArr = [];
      if (data.status)
        data.result.map((item) => {
          opinionsArr.push({
            label: item.title,
            value: item.id,
          });
        });
      setQuestions(opinionsArr);
    });
  }, [opinion]);

  const getReportsData = () => {
    setIsAdvanced(true);
    setLoading(true);
    setShowItem(false);

    const postedData = {
      p_opinion_id: opinion || 0,
      p_guild_id: 0,
      p_business_id: 0,
      branchId: [],
      p_cityid: cityId,
    };
    if(fromDate)
        postedData.p_fromdate = convertToGregorian(fromDate)
    if(toDate)
        postedData.p_todate = convertToGregorian(toDate)

    getReports(postedData)
      .then(({ data }) => {
        setLoading(false);
        setShowItem(true);

        if (data.status && data.result) {

          console.log(data.result.v_result);
          const dataNew = data.result.v_result.reduce((acc, item) => {
            const quItem = questions?.find(
              (it) => it.value === questionId
            )?.label;

            if (item.q_title === quItem) {
              return {
                ...acc,
                [item.q_title]: {
                  ...acc[item.q_title],
                  [`${item.bu_title} (${item.cnt_use || 0}) `]: item.avg_point,
                },
              };
            } else {
              return { ...acc };
            }
          }, {});

          let cats = undefined;
          let sum = 0;

          const points = Object.values(Object.values(dataNew)[0]).sort((a, b) => b - a);
          points.forEach((item) => {
            sum += item;
          });
          const avg = Math.floor(sum / points.length);

          const sortable = Object.entries(Object.values(dataNew)[0])
            .sort(([, a], [, b]) => b - a)



          setRows(
            Object.keys(dataNew).map(function (name) {
              if (!cats) {
                cats = sortable.map(item => item[0]);
              }
              return {
                name,
                data: sortable.map(function (item) {
                  return {
                    y: item[1],
                    x: name,
                    goals: [
                      {
                        name: "میانگین",
                        value: avg,
                        strokeWidth: 5,
                        strokeHeight: 10,
                        strokeColor: "#ff0000",
                      },
                    ],
                  };
                }),
              };
            })
          );


          setOptions({
            chart: {
              type: "bar",
              height: 2000,
              stacked: true,
              fontSize: "8px",
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            colors: [
              "#33b2df",
              "#546E7A",
              "#d4526e",
              "#13d8aa",
              "#A5978B",
              "#2b908f",
              "#f9a3a4",
              "#90ee7e",
              "#f48024",
              "#69d2e7",
            ],
            dataLabels: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: "12px",
                colors: ["#fff"],
              },
            },
            tooltip: {
              shared: true,
              intersect: false,
            },
            stroke: {
              show: true,
              width: 1,
              colors: ["#fff"],
            },
            xaxis: {
              categories: cats,
              labels: {
                formatter: function (val) {
                  return "";
                },
                style: {
                  fontSize: "8px !important",
                },
              },
            },
            legend: {
              position: "top",
              horizontalAlign: "center",
              offsetX: 10,
            },
          });
        } else setRows([]);
      })
      .finally(() => {
        setIsSearched(true);
      });
  };


  const advancedSearch = (e) => {
    e.preventDefault();
    getReportsData();
    setIsAdvanced(true);
  };

  const resetAdvancedSearch = (e) => {
    e.preventDefault();
    setIsAdvanced(false);
    setIsSearched(false);

    setOpinion(0);
    setBranchId([]);

    setOptions({});
    setRows({});
  };


  /*   console.log(rows.length !== 0 ? Object.values(rows[0])[1]?.sort((a, b) => b.y - a.y) : "");
   */
  return (
    <div className="row">
      <div className="col-md-2">
        <div className="form-group">
          <label>نظرسنجی</label>
          {opinion ? (
            <i
              className="fe fe-x clear-select-btn"
              onClick={(e) => setOpinion(0)}
            ></i>
          ) : (
            ""
          )}
          <ReactSelect
            noOptionsMessage={(e) => "یافت نشد"}
            placeholder="انتخاب کنید"
            options={opinions}
            value={opinions.filter((b) => b.value == opinion)}
            onChange={(e) => setOpinion(e.value)}
          />
        </div>
      </div>

      <div className="col-md-2">
        <label> سوالات نظرسنجی</label>
        <ReactSelect
          noOptionsMessage={(e) => "یافت نشد"}
          placeholder="انتخاب کنید"
          options={questions}
          value={questions.filter((b) => b.value == questionId)}
          onChange={(e) => setQuestionId(e.value)}
        />
      </div>

      <div className="col-md-2">
        <div className="form-group">
          <label>استان</label>
          <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={provinces} value={provinces.filter(item => item.value == provinceId)} onChange={e => setProvinceId(e.value)} />
        </div>
      </div>
      <div className="col-md-2">
        <div className="form-group">
          <label>شهر</label>
          <ReactSelect noOptionsMessage={e => 'یافت نشد'} disabled={!provinces.length} placeholder="انتخاب کنید" isDisabled={!cities.length} options={cities} value={cities.filter(item => item.value == cityId)} onChange={e => setCityId(e.value)} />
        </div>
      </div>
      <div className="col-md-2">
          <div className="form-group">
              <label>از تاریخ</label>
              {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
              <DatePicker
                  name="fromDate"
                  required
                  locale="fa"
                  shouldHighlightWeekends
                  value={fromDate}
                  onChange={setFromDate}
                  className="form-control"
                  inputPlaceholder='تاریخ  را انتخاب کنید ...'
              />
          </div>
      </div>
      <div className="col-md-2">
          <div className="form-group">
              <label>از تاریخ</label>
              {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
              <DatePicker
                  name="toDate"
                  required
                  locale="fa"
                  shouldHighlightWeekends
                  value={toDate}
                  onChange={setToDate}
                  className="form-control"
                  inputPlaceholder='تاریخ  را انتخاب کنید ...'
              />
          </div>
      </div>

      <div
        className="py-2 col-md-2"
        style={{ marginTop: 25, textAlign: "center" }}
      >
        {showItem && (
          <>
            {" "}
            <button className="btn btn-primary"
              disabled={!opinion || !questionId}
              onClick={advancedSearch}>
              جستجو
            </button>
            {isAdvanced && (
              <button
                className="btn btn-danger mx-2"
                onClick={resetAdvancedSearch}
              >
                حذف فیلتر
              </button>
            )}
          </>
        )}
      </div>

      {isLoading ? (
        <div className="lds-facebook mt-4">
          <div></div>
          <div></div>
          <div></div>
        </div>
      ) : (
        <>
          {rows.length ? (
            <div className="col-md-12 mt-3">
              <div id="chart" dir="ltr">
                <ReactApexChart
                  options={options}
                  series={rows}
                  type="bar"
                  height={2000}
                />
              </div>
            </div>
          ) : isSearched ? (
            <div className="col-md-12 mt-2">
              <div className="alert alert-primary">
                <p>داده ای جهت نمایش یافت نشد</p>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};

export default RankOpinionQuestion;
